import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { sections } from '../../data/sections';
import { Home, Lock, Play, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
interface SidebarProps {
  isOpen?: boolean;
  onClose?: () => void;
}
export function Sidebar({
  isOpen = false,
  onClose
}: SidebarProps) {
  const handleNavClick = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    if (onClose) onClose();
  };
  const handleLibraryClick = () => {
    document.getElementById('training-library')?.scrollIntoView({
      behavior: 'smooth'
    });
    if (onClose) onClose();
  };
  const SidebarContent = () => <>
      <Link to="/" onClick={handleNavClick} className="flex h-16 shrink-0 items-center px-6 border-b transition-colors hover:bg-muted/40" data-id="element-96">
        <div className="flex items-center gap-3" data-id="element-97">
          <img src="https://cdn.magicpatterns.com/uploads/avqgHrdxVGXkmw7ePFFRH3/ChatGPT_Image_May_15,_2026,_10_04_03_PM.png" alt="CES Mobile Truck Repair" className="h-10 w-10 object-contain shrink-0" data-id="element-98" />
          <div className="flex flex-col" data-id="element-99">
            <span className="font-bold text-sm leading-tight text-foreground" data-id="element-100">
              Home
            </span>
            <span className="text-xs text-muted-foreground font-medium" data-id="element-101">
              Operations Portal
            </span>
          </div>
        </div>
      </Link>

      <div className="flex-1 overflow-y-auto py-6 px-4 custom-scrollbar" data-id="element-102">
        <nav className="mb-6 space-y-1" data-id="element-103">
          <NavLink to="/" end onClick={handleNavClick} className="flex items-center gap-3 rounded-md px-3 py-2.5 text-sm font-medium text-muted-foreground hover:bg-muted hover:text-foreground transition-colors" data-id="element-104">
            <Home className="h-4 w-4 shrink-0" data-id="element-105" />
            <span className="truncate" data-id="element-106">Home</span>
          </NavLink>
          <button onClick={handleLibraryClick} className="flex w-full items-center gap-3 rounded-md px-3 py-2.5 text-sm font-medium text-muted-foreground hover:bg-muted hover:text-foreground transition-colors" data-id="element-107">
            <Play className="h-4 w-4 shrink-0" data-id="element-108" />
            <span className="truncate" data-id="element-109">Training Library</span>
          </button>
        </nav>

        <div className="mb-4 px-2" data-id="element-110">
          <h2 className="text-xs font-semibold uppercase tracking-wider text-muted-foreground" data-id="element-111">
            Playbook Sections
          </h2>
        </div>
        <nav className="space-y-1" data-id="element-112">
          {sections.map(section => {
          const Icon = section.icon;
          return <NavLink key={section.id} to={`/section/${section.id}`} onClick={() => {
            window.scrollTo({
              top: 0,
              behavior: 'smooth'
            });
            if (onClose) onClose();
          }} className={({
            isActive
          }) => `flex items-center gap-3 rounded-md px-3 py-2.5 text-sm font-medium transition-colors ${isActive ? 'bg-primary/10 text-primary' : 'text-muted-foreground hover:bg-muted hover:text-foreground'}`} data-id="element-113">
                <Icon className="h-4 w-4 shrink-0" data-id="element-114" />
                <span className="truncate" data-id="element-115">
                  {section.number}. {section.title}
                </span>
              </NavLink>;
        })}
        </nav>
      </div>

      <div className="border-t p-4" data-id="element-116">
        <div className="flex items-center gap-2 rounded-md bg-muted/40 px-3 py-2 text-xs text-muted-foreground" data-id="element-117">
          <Lock className="h-3.5 w-3.5 shrink-0" data-id="element-118" />
          <span className="leading-tight" data-id="element-119">
            Private &amp; confidential. Prepared exclusively for the prospective
            buyer.
          </span>
        </div>
      </div>
    </>;
  return <>
      {/* Desktop Sidebar */}
      <aside className="fixed inset-y-0 left-0 z-40 hidden w-72 flex-col border-r bg-card/50 backdrop-blur-xl lg:flex" data-id="element-120">
        <SidebarContent data-id="element-121" />
      </aside>

      {/* Mobile Sidebar */}
      <AnimatePresence data-id="element-122">
        {isOpen && <>
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} onClick={onClose} className="fixed inset-0 z-40 bg-background/80 backdrop-blur-sm lg:hidden" data-id="element-123" />
            <motion.aside initial={{
          x: '-100%'
        }} animate={{
          x: 0
        }} exit={{
          x: '-100%'
        }} transition={{
          type: 'spring',
          bounce: 0,
          duration: 0.3
        }} className="fixed inset-y-0 left-0 z-50 w-72 flex flex-col border-r bg-card shadow-2xl lg:hidden" data-id="element-124">
              <button onClick={onClose} className="absolute right-4 top-5 flex h-6 w-6 items-center justify-center rounded-md text-muted-foreground hover:bg-muted hover:text-foreground" data-id="element-125">
                <X className="h-5 w-5" data-id="element-126" />
              </button>
              <SidebarContent data-id="element-127" />
            </motion.aside>
          </>}
      </AnimatePresence>
    </>;
}